"use client";

import React, { ReactNode } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

type KeenSliderProps = {
  children: ReactNode;
};

const KeenSlider: React.FC<KeenSliderProps> = ({ children }) => {
  return (
    <div className="relative w-full">
      {/* Slider */}
      <Swiper
        // ref={sliderRef}
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true, // pause when hovered
        }}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
        }}
      >
        {React.Children.map(children, (child) => (
          <SwiperSlide>
            <div>{child}</div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Left Button */}
      <button
        // onClick={() => sliderInstance.current?.prev()}
        className="custom-prev absolute h-[40px] flex items-center cursor-pointer justify-center w-[40px] top-1/2 left-3 xl:left-[0]  md:left-[-60px] -translate-y-1/2 z-10  px-1 py-1 border border-white shadow"
      >
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.57 6.42999L3.5 12.5L9.57 18.57"
            stroke="white"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.5 12.5L3.67 12.5"
            stroke="white"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        // onClick={() => sliderInstance.current?.next()}
        className="custom-next absolute h-[40px] flex items-center cursor-pointer justify-center w-[40px] top-1/2 right-3 md:right-[-60px]  xl:right-[0]  -translate-y-1/2 z-1 px-1 py-1 border border-white shadow"
      >
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.4301 6.42999L20.5001 12.5L14.4301 18.57"
            stroke="white"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.5 12.5L20.33 12.5"
            stroke="white"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default KeenSlider;
